// TODO: Pass allows_configurable_expiry_urls? in to slim or erb so we don't have to declare these twice

const CONFIGURABLE_EXPIRY_ORG_KEYS = [
  'cxrwwgr49gvznv5hr6svf6rj', // Cisco Brand (ESC-16548)
  'nnfm7pq5mpvkmcfjb7vsc4s', // Cisco Thousand Eyes (ESC-16548)
  '3vw92tjmbkwp8w372kwscfjm', // Cisco Security (ESC-16548)
  'rw99bbqh29ht4bv8nrmwfr2x', // Cisco (ESC-16548)
  'c92vqw6cx4gkq8fzj88pxncb', // Webex by Cisco (ESC-16548)
  'pjoo62-1t0320-fqe67k', // Cisco Meraki (ESC-16548)
  '275pfpp75hrnhkn5kjbmj87', // Samsung
  'fk9gpv64fvk2k9r58gcf5pr', // Stage Configurable Expiry
];

export const useConfigurableExpiryUrls = BFG.organization_key ? CONFIGURABLE_EXPIRY_ORG_KEYS.includes(BFG.organization_key) : false;
